webpackJsonp([1],{

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "ui large negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Error at line " + _vm._s(_vm.lineNumber) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('pre', {
    attrs: {
      "id": "ace-editor"
    }
  }, [_vm._v(_vm._s(_vm.code))]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui buttons",
    attrs: {
      "id": "buttons"
    }
  }, [_c('button', {
    staticClass: "ui green button",
    attrs: {
      "id": "run-btn"
    }
  }, [_vm._v("Run")]), _vm._v(" "), _c('div', {
    staticClass: "or"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui blue button",
    attrs: {
      "id": "debug-btn"
    }
  }, [_vm._v("Debug")]), _vm._v(" "), _c('div', {
    staticClass: "or"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui grey button",
    attrs: {
      "id": "reset-btn"
    }
  }, [_vm._v("Reset")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui four column stackable grid",
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('intro-modal', {
    on: {
      "closeModal": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('pin-diagram')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('memory')], 1), _vm._v(" "), _c('div', {
    staticClass: "center aligned column"
  }, [_c('router-view', {
    staticClass: "ui basic segment"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('editor')], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Pin Diagram")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Memory")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Peripherals")])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned center aligned column"
  }, [_c('h2', {
    staticClass: "ui header"
  }, [_vm._v("Editor")]), _vm._v(" "), _c('div', {
    staticClass: "ui stackable labels"
  }, [_c('span', {
    staticClass: "ui green label"
  }, [_vm._v("Current line")]), _vm._v(" "), _c('span', {
    staticClass: "ui blue label"
  }, [_vm._v("Next line (PC)")]), _vm._v(" "), _c('span', {
    staticClass: "ui red label"
  }, [_vm._v("Error line")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SevenSegment_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5894256a_node_modules_vue_loader_lib_selector_type_template_index_0_SevenSegment_vue__ = __webpack_require__(110);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SevenSegment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5894256a_node_modules_vue_loader_lib_selector_type_template_index_0_SevenSegment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      portNum: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */](['getP0', 'getP1', 'getP2', 'getP3']),
  mounted: function mounted() {
    var _this = this;

    var toBin = this.$store.state.utils.convertToBin;
    this.$store.subscribe(function () {
      var port = toBin(_this['getP' + _this.portNum]());
      __WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_1_lodash__["range"](7), function (i) {
        var elt = _this.$el.querySelector('#segment' + i);
        elt.style.fill = port[7 - i] === '1' ? 'red' : 'none';
      });
    });
  }
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 156 195.6",
      "version": "1"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "#000",
      "transform": "translate(-82 -56.5)"
    }
  }, [_c('path', {
    attrs: {
      "id": "segment6",
      "d": "M190.8 72.5 175.6 88h-59L101 72.5 116.7 57h59L191 72.5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "141.7",
      "y": "77.1",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("A")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment5",
      "d": "M194 75.4l15.5 15.2v45L194 151l-15.5-15.4v-45L194 75.4z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "189.5",
      "y": "117.8",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("B")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment4",
      "d": "M194 157.4l15.5 15.3v45L194 233.2l-15.5-15.5v-45l15.5-15.3z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "189.6",
      "y": "199.9",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("C")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment3",
      "d": "M190.8 236l-15.2 15.6h-59L101 236l15.6-15.4h59l15.2 15.5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "140.9",
      "y": "240.6",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("D")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment2",
      "d": "M98 157.4l15.5 15.3v45L98 233.2l-15.5-15.5v-45L98 157.4z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "93.8",
      "y": "199.9",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("E")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment1",
      "d": "M98 75.4l15.5 15.2v45L98 151l-15.5-15.4v-45L98 75.4z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "94.2",
      "y": "117.8",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("F")])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "segment0",
      "d": "M190.8 154l-15.2 15.5h-59L101 154l15.6-15.5h59l15.2 15.5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "141.2",
      "y": "158.6",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("G")])]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "225.3",
      "cy": "239.3",
      "r": "12.3",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "216.7",
      "y": "244.7",
      "font-family": "sans-serif"
    }
  }, [_c('tspan', [_vm._v("DP")])])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portNum),
      expression: "portNum"
    }],
    attrs: {
      "id": "port-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.portNum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(i) {
    return _c('option', {
      domProps: {
        "value": i - 1
      }
    }, [_vm._v("Port " + _vm._s(i - 1))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Motor_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbd12a1_node_modules_vue_loader_lib_selector_type_template_index_0_Motor_vue__ = __webpack_require__(114);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dbd12a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Motor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbd12a1_node_modules_vue_loader_lib_selector_type_template_index_0_Motor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      portPinNum1: 0.0,
      portPinNum2: 0.1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */](['getP0', 'getP1', 'getP2', 'getP3']), {
    portNum1: function portNum1() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["floor"](this.portPinNum1);
    },
    portNum2: function portNum2() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["floor"](this.portPinNum2);
    },
    pinNum1: function pinNum1() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["floor"]((this.portPinNum1 % 1).toFixed(1) * 10);
    },
    pinNum2: function pinNum2() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["floor"]((this.portPinNum2 % 1).toFixed(1) * 10);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var toBin = this.$store.state.utils.convertToBin;
    var rotator = this.$el.querySelector('#rotator');

    this.$store.subscribe(function () {
      var pin1 = toBin(_this['getP' + _this.portNum1]())[7 - _this.pinNum1];
      var pin2 = toBin(_this['getP' + _this.portNum2]())[7 - _this.pinNum2];
      var motorClass = '';

      if (pin1 === pin2) {
        motorClass = 'neutral';
      } else if (pin1 === '1' && pin2 === '0') {
        motorClass = 'clockwise';
      } else {
        motorClass = 'counter-clockwise';
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"](rotator.children, function (child) {
        child.setAttribute('class', 'motor ' + motorClass);

        rotator.replaceChild(child.cloneNode(true), child);
      });
    });
  }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 340 406.8",
      "version": "1"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "#000"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(-90 82.933 439.114)"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "372",
      "cy": "526.2",
      "r": "149.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M115.2 695.7H372v-20m-256.8-319H372v19.7"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "rotator",
      "stroke-width": "10px",
      "transform": "translate(-202.047 -376.18)"
    }
  }, [_c('circle', {
    staticClass: "motor neutral",
    attrs: {
      "cx": "372",
      "cy": "526.2",
      "r": "124",
      "stroke-width": ".8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "motor neutral",
    attrs: {
      "d": "M379.7 387.5l-15 15 15 15M364.4 635l15 15-15 15"
    }
  })])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portPinNum1),
      expression: "portPinNum1"
    }],
    attrs: {
      "id": "port-pin1-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.portPinNum1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(i) {
    return _c('optgroup', {
      attrs: {
        "label": 'Port ' + (i - 1)
      }
    }, _vm._l((8), function(j) {
      return _c('option', {
        domProps: {
          "value": (i - 1) + ((j - 1) / 10)
        }
      }, [_vm._v("Pin P" + _vm._s((i - 1) + '.' + (j - 1)))])
    }))
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portPinNum2),
      expression: "portPinNum2"
    }],
    attrs: {
      "id": "port-pin2-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.portPinNum2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(i) {
    return _c('optgroup', {
      attrs: {
        "label": 'Port ' + (i - 1)
      }
    }, _vm._l((8), function(j) {
      return _c('option', {
        domProps: {
          "value": (i - 1) + ((j - 1) / 10)
        }
      }, [_vm._v("Pin P" + _vm._s((i - 1) + '.' + (j - 1)))])
    }))
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdcDacSlider_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eac95cb_node_modules_vue_loader_lib_selector_type_template_index_0_AdcDacSlider_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5eac95cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdcDacSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eac95cb_node_modules_vue_loader_lib_selector_type_template_index_0_AdcDacSlider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      negVref: 0,
      portNum: 0,
      portValue: 0,
      posVref: 5,
      vin: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */](['getP0', 'getP1', 'getP2', 'getP3']), {
    effVref: function effVref() {
      return this.posVref - this.negVref;
    }
  }),
  watch: {
    portValue: function portValue(value) {
      this.vin = value * (this.effVref / 255) + this.negVref;
      this.setPort([this.portNum, __WEBPACK_IMPORTED_MODULE_2_lodash__["round"](value)]);
    },
    vin: function vin(value) {
      this.portValue = (value - this.negVref) * (255 / this.effVref);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */](['setPort']),
  mounted: function mounted() {
    var _this = this;

    this.$store.subscribe(function (mutation) {
      if (mutation.type !== 'setPort') {
        var port = _this['getP' + _this.portNum]();
        _this.portValue = port;
      }
    });
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui padded basic segment"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.posVref),
      expression: "posVref",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.posVref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.posVref = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.portValue),
      expression: "portValue",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "adc-dac-range",
      "max": "255"
    },
    domProps: {
      "value": (_vm.portValue)
    },
    on: {
      "__r": function($event) {
        _vm.portValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.vin),
      expression: "vin",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "vin",
      "min": _vm.negVref,
      "max": _vm.posVref,
      "step": "any"
    },
    domProps: {
      "value": (_vm.vin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vin = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.negVref),
      expression: "negVref",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "id": "negVref"
    },
    domProps: {
      "value": (_vm.negVref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.negVref = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portNum),
      expression: "portNum"
    }],
    attrs: {
      "id": "port-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.portNum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(i) {
    return _c('option', {
      domProps: {
        "value": i - 1
      }
    }, [_vm._v("Port " + _vm._s(i - 1))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(39);



function run(input) {
  return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].handleExecution(input);
}

function debug(input) {
  return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].executeNextLine(input);
}

function reset(input) {
  __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].initValues(input);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  debug: debug,
  memory: __WEBPACK_IMPORTED_MODULE_0__data__["a" /* default */],
  run: run,
  utils: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */],
  reset: reset
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(39);






function setb(bitAddr) {
  var _utils$translateToBit = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(bitAddr),
      _utils$translateToBit2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit, 2),
      addr = _utils$translateToBit2[0],
      bit = _utils$translateToBit2[1];

  var binary = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].changeBit(addr, bit, 1);
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] = __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](binary, 2);
}

function clr(bitAddr) {
  var _utils$translateToBit3 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(bitAddr),
      _utils$translateToBit4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit3, 2),
      addr = _utils$translateToBit4[0],
      bit = _utils$translateToBit4[1];

  if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](bit)) {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] = 0;
  } else {
    var binary = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].changeBit(addr, bit, 0);
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] = __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](binary, 2);
  }
}

function mov(addr1, addr2) {
  var _ref2, _utils$translateToBit7, _utils$translateToBit8;

  var carry = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7';
  var _ref = [__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW'), 7],
      byteAddr1 = _ref[0],
      bit1 = _ref[1];

  var _utils$translateToBit5 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr2),
      _utils$translateToBit6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit5, 2),
      byteAddr2 = _utils$translateToBit6[0],
      bit2 = _utils$translateToBit6[1];

  if (addr1 === carry || addr2 === carry && (_ref2 = [__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW'), 7], byteAddr2 = _ref2[0], bit2 = _ref2[1], _ref2) && (_utils$translateToBit7 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr1), _utils$translateToBit8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit7, 2), byteAddr1 = _utils$translateToBit8[0], bit1 = _utils$translateToBit8[1], _utils$translateToBit7)) {
    if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(byteAddr2, bit2)) {
      setb(byteAddr1 + '.' + bit1);
    } else {
      clr(byteAddr1 + '.' + bit1);
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2];
  }
}

function cpl(bitAddr) {
  var _utils$translateToBit9 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(bitAddr),
      _utils$translateToBit10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit9, 2),
      addr = _utils$translateToBit10[0],
      bit = _utils$translateToBit10[1];

  if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](bit)) {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] = 255 - __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr];
  } else if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(addr, bit)) {
    clr(bitAddr);
  } else {
    setb(bitAddr);
  }
}

function add(addr1, addr2) {
  var _map = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"]([addr1, addr2], function (addr) {
    return __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr];
  }),
      _map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_map, 2),
      num1 = _map2[0],
      num2 = _map2[1];

  var _map3 = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"]([num1, num2], function (num) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(num).slice(4), 2);
  }),
      _map4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_map3, 2),
      nib1 = _map4[0],
      nib2 = _map4[1];

  var psw = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW');

  if (nib1 + nib2 > 15) {
    setb(psw + '.6');
  } else {
    clr(psw + '.6');
  }

  if (num1 + num2 > 255) {
    setb(psw + '.2');
    setb(psw + '.7');
  } else {
    clr(psw + '.2');
    clr(psw + '.7');
  }

  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] = num1 + num2;
}

function addc(addr1, addr2) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] += __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW'), 7) ? 1 : 0;
  add(addr1, addr2);
}

function subb(addr1, addr2) {
  var _map5 = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"]([addr1, addr2], function (addr) {
    return __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr];
  }),
      _map6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_map5, 2),
      num1 = _map6[0],
      num2 = _map6[1];

  var _map7 = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"]([num1, num2], function (num) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(num).slice(4), 2);
  }),
      _map8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_map7, 2),
      nib1 = _map8[0],
      nib2 = _map8[1];

  var psw = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW');

  if (nib1 < nib2) {
    setb(psw + '.6');
  } else {
    clr(psw + '.6');
  }

  if (num1 < num2) {
    setb(psw + '.7');
  } else {
    clr(psw + '.7');
  }

  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] = num1 - (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(psw, 7) ? 1 : 0) - num2;
}

function mul(addr) {
  var psw = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW');
  var a = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A');
  var b = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('B');
  var product = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] * __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b];

  clr(psw + '.7');
  if (product > 255) {
    var binary = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(product, 16);
    setb(psw + '.2');
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] = __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](binary.slice(8), 2);
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b] = __WEBPACK_IMPORTED_MODULE_1_lodash__["parseInt"](binary.slice(0, 8), 2);
  } else {
    clr(psw + '.2');
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] = product;
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b] = 0;
  }
}

function div(addr) {
  var psw = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW');
  var a = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A');
  var b = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('B');

  clr(psw + '.7');
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b] === 0) {
    setb(psw + '.2');
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] = 0;
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b] = 0;
  } else {
    clr(psw + '.2');
    var quotient = __WEBPACK_IMPORTED_MODULE_1_lodash__["floor"](__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] / __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b]);
    var remainder = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] % __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b];
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[a] = quotient;
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[b] = remainder;
  }
}

function jump(label) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].labels.get(label.toLowerCase());
}

function ajmp(label) {
  jump(label);
}

function ljmp(label) {
  jump(label);
}

function sjmp(label) {
  jump(label);
}

function djnz(addr, label) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] -= 1;
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] > 0) {
    jump(label);
  }
}

function jumpBit(bitAddr, label, ifBitSet, clearBeforeJump) {
  var _utils$translateToBit11 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(bitAddr),
      _utils$translateToBit12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit11, 2),
      addr = _utils$translateToBit12[0],
      bit = _utils$translateToBit12[1];

  if (ifBitSet === __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(addr, bit)) {
    if (clearBeforeJump) {
      clr(bitAddr);
    }
    jump(label);
  }
}

function jbc(bitAddr, label) {
  jumpBit(bitAddr, label, true, true);
}

function jb(bitAddr, label) {
  jumpBit(bitAddr, label, true, false);
}

function jnb(bitAddr, label) {
  jumpBit(bitAddr, label, false, false);
}

function jc(label) {
  jb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7', label);
}

function jnc(label) {
  jnb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7', label);
}

function jz(label) {
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')] === 0) {
    jump(label);
  }
}

function jnz(label) {
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')] !== 0) {
    jump(label);
  }
}

function cjne(addr1, addr2, label) {
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] < __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2]) {
    setb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
  } else {
    clr(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
  }

  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] !== __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2]) {
    jump(label);
  }
}

function call(label) {
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP')] + 2 > 0x7F) {
    return { status: false, msg: 'Stack Overflow' };
  }
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounterStack.push(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter);
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP')] + 1] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter;
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP')] + 2] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter;
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP')] += 2;
  jump(label);
  return { status: true };
}

function lcall(label) {
  return call(label);
}

function acall(label) {
  return call(label);
}

function inc(addr) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] += 1;
}

function dec(addr) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] -= 1;
}

function nop() {}

function updateParity() {
  var acc = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')]);
  if ((__WEBPACK_IMPORTED_MODULE_1_lodash__["countBy"](__WEBPACK_IMPORTED_MODULE_1_lodash__["toArray"](acc))['1'] || 0) % 2 === 0) {
    clr(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.0');
  } else {
    setb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.0');
  }
}

function rotateA(addr, right, withCarry) {
  var originalA = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')]);
  var C = void 0;
  var rotatedA = void 0;
  if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW'), 7)) {
    C = '1';
  } else {
    C = '0';
  }

  if (right) {
    if (withCarry) {
      rotatedA = '' + C + originalA.slice(0, 7);
      if (originalA.slice(-1) === '1') {
        setb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
      } else {
        clr(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
      }
    } else {
      rotatedA = '' + originalA.slice(-1) + originalA.slice(0, 7);
    }
  } else if (withCarry) {
    rotatedA = '' + originalA.slice(1, 8) + C;
    if (originalA.slice(0, 1) === '1') {
      setb(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
    } else {
      clr(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW') + '.7');
    }
  } else {
    rotatedA = '' + originalA.slice(1, 8) + originalA.slice(0, 1);
  }

  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')] = parseInt(rotatedA, 2);
}

function rr(addr) {
  rotateA(addr, true, false);
}

function rrc(addr) {
  rotateA(addr, true, true);
}

function rl(addr) {
  rotateA(addr, false, false);
}

function rlc(addr) {
  rotateA(addr, false, true);
}

function swap(addr) {
  var A = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')]);
  var lowerNibble = A.slice(4);
  var higherNibble = A.slice(0, 4);
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')] = parseInt('' + lowerNibble + higherNibble, 2);
}

function push(addr) {
  var SP = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP');
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[SP] += 1;
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[SP]] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr];
}

function pop(addr) {
  var SP = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP');
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[SP]];
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[SP] -= 1;
}

function xchd(addr1, addr2) {
  var A = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')]);
  var binaryOfAddr2 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2]);
  var lNibA = A.slice(4);
  var hNibA = A.slice(0, 4);
  var lNibAddr2 = binaryOfAddr2.slice(4);
  var hNibAddr2 = binaryOfAddr2.slice(0, 4);
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A')] = parseInt('' + hNibA + lNibAddr2, 2);
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2] = parseInt('' + hNibAddr2 + lNibA, 2);
}

function xch(addr1, addr2) {
  var temp = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1];
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2];
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2] = temp;
}

function da(addr) {
  var A = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('A');
  var PSW = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('PSW');
  var lNibA = parseInt(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[A]).slice(4), 2);
  var hNibA = parseInt(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].convertToBin(__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[A]).slice(0, 4), 2);
  var num = 0;
  if (lNibA > 9 && hNibA > 9) {
    num = 102;
  } else if (lNibA > 9) {
    num = 6;
  } else if (hNibA > 9) {
    num = 96;
  }
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[A] += num;
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[A] > 153) {
    setb(PSW + '.7');
  } else {
    clr(PSW + '.7');
  }
}

function anl(addr1, addr2) {
  var _utils$translateToBit13 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr1),
      _utils$translateToBit14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit13, 2),
      byteAddr1 = _utils$translateToBit14[0],
      bit1 = _utils$translateToBit14[1];

  if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](bit1)) {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] &= __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2];
  } else {
    var _utils$translateToBit15 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr2),
        _utils$translateToBit16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit15, 2),
        byteAddr2 = _utils$translateToBit16[0],
        bit2 = _utils$translateToBit16[1];

    if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(byteAddr1, bit1) && __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(byteAddr2, bit2)) {
      setb(byteAddr1 + '.' + bit1);
    } else {
      clr(byteAddr1 + '.' + bit1);
    }
  }
}

function orl(addr1, addr2) {
  var _utils$translateToBit17 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr1),
      _utils$translateToBit18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit17, 2),
      byteAddr1 = _utils$translateToBit18[0],
      bit1 = _utils$translateToBit18[1];

  if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](bit1)) {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] |= __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2];
  } else {
    var _utils$translateToBit19 = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].translateToBitAddressable(addr2),
        _utils$translateToBit20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a(_utils$translateToBit19, 2),
        byteAddr2 = _utils$translateToBit20[0],
        bit2 = _utils$translateToBit20[1];

    if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(byteAddr1, bit1) || __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].isBitSet(byteAddr2, bit2)) {
      setb(byteAddr1 + '.' + bit1);
    } else {
      clr(byteAddr1 + '.' + bit1);
    }
  }
}

function xrl(addr1, addr2) {
  __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr1] ^= __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[addr2];
}

function ret() {
  var executionStatus = { status: true };
  if (__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounterStack.length > 0) {
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounterStack.pop();
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].sfrMap.get('SP')] -= 2;
  } else {
    executionStatus = { status: false, msg: 'Stack Underflow' };
    __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].resetMemory = true;
    __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].programCounter = __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */].code.length + 1;
  }
  return executionStatus;
}

function reti() {
  return ret();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  setb: setb,
  clr: clr,
  mov: mov,
  cpl: cpl,
  add: add,
  addc: addc,
  subb: subb,
  mul: mul,
  div: div,
  ajmp: ajmp,
  ljmp: ljmp,
  sjmp: sjmp,
  djnz: djnz,
  jbc: jbc,
  jb: jb,
  jnb: jnb,
  jc: jc,
  jnc: jnc,
  jz: jz,
  jnz: jnz,
  cjne: cjne,
  lcall: lcall,
  acall: acall,
  anl: anl,
  orl: orl,
  xrl: xrl,
  rl: rl,
  rlc: rlc,
  rr: rr,
  rrc: rrc,
  da: da,
  swap: swap,
  xch: xch,
  xchd: xchd,
  push: push,
  pop: pop,
  inc: inc,
  dec: dec,
  nop: nop,
  ret: ret,
  reti: reti,
  updateParity: updateParity
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(39);



var sfrMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['A', 0xE0], ['B', 0xF0], ['PSW', 0xD0], ['P0', 0x80], ['P1', 0x90], ['P2', 0xA0], ['P3', 0xB0], ['SP', 0x81], ['DPL', 0x82], ['DPH', 0x83], ['PCON', 0x87], ['TCON', 0x88], ['TMOD', 0x89], ['TL0', 0x8A], ['TL1', 0x8B], ['TH0', 0x8C], ['TH1', 0x8D], ['SCON', 0x98], ['SBUF', 0x99], ['IE', 0xA8], ['IP', 0xB8]]);

var ram = new Uint8Array(257);
ram[sfrMap.get('SP')] = 0x07;

var instructionCheck = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['setb', function (operands) {
  if (operands.length === 1) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[0])) {
      return { status: false, msg: 'Invalid operand' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['clr', function (operands) {
  if (operands.length === 1) {
    if (!(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[0]) || parseInt(operands[0], 10) === sfrMap.get('A'))) {
      return { status: false, msg: 'Operand must be bit-address OR accumulator' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['mov', function (operands) {
  if (operands.length === 2) {
    if (isNaN(parseInt(operands[0], 10)) || isNaN(parseInt(operands[1], 10))) {
      return { status: false, msg: 'Invalid operands' };
    } else if (operands[0] === sfrMap.get('PSW') + '.7' || operands[1] === sfrMap.get('PSW') + '.7') {
      if (!(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[0]) && __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[1]))) {
        return { status: false, msg: 'Invalid operands' };
      }
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isRtoR(operands[0], operands[1])) {
      return { status: false, msg: 'Both operands cannot access register bank simultaneously' };
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isPortToPort(operands[0], operands[1])) {
      return { status: false, msg: 'Cannot move data from port to port' };
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isSFRtoSFR(operands[0], operands[1])) {
      return { status: false, msg: 'Both operands cannot be SFRs' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['cpl', function (operands) {
  return instructionCheck.get('clr')(operands);
}], ['add', function (operands) {
  if (operands.length === 2) {
    if (parseInt(operands[0], 10) !== sfrMap.get('A')) {
      return { status: false, msg: '1st operand must be accumulator' };
    } else if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
      return { status: false, msg: 'Invalid 2nd operand' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['addc', function (operands) {
  return instructionCheck.get('add')(operands);
}], ['subb', function (operands) {
  return instructionCheck.get('add')(operands);
}], ['mul', function (operands) {
  if (operands.length === 1) {
    if (!/^AB$/i.test(operands[0])) {
      return { status: false, msg: "Operand must be 'AB'" };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['div', function (operands) {
  return instructionCheck.get('mul')(operands);
}], ['ajmp', function (operands) {
  if (operands.length === 1) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isLabel(operands[0])) {
      return { status: false, msg: 'Invalid label' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['ljmp', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['sjmp', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['djnz', function (operands) {
  if (operands.length === 2) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      return { status: false, msg: 'Invalid 1st operand' };
    }
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isLabel(operands[1])) {
      return { status: false, msg: 'Invalid label' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['jbc', function (operands) {
  if (operands.length === 2) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[0])) {
      return { status: false, msg: 'Invalid 1st operand' };
    }
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isLabel(operands[1])) {
      return { status: false, msg: 'Invalid label' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['jb', function (operands) {
  return instructionCheck.get('jbc')(operands);
}], ['jnb', function (operands) {
  return instructionCheck.get('jbc')(operands);
}], ['jc', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['jnc', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['jz', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['jnz', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['cjne', function (operands) {
  if (operands.length === 3) {
    if (parseInt(operands[0], 10) === sfrMap.get('A')) {
      if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      if (operands[1] !== '256') {
        return { status: false, msg: '2nd operand must be immediate data if 1st operand is not accumulator' };
      }
    } else {
      return { status: false, msg: 'Invalid 1st operand' };
    }
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isLabel(operands[2])) {
      return { status: false, msg: 'Invalid label' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['lcall', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['acall', function (operands) {
  return instructionCheck.get('ajmp')(operands);
}], ['anl', function (operands) {
  if (operands.length === 2) {
    if (operands[0] === sfrMap.get('PSW') + '.7') {
      if (!(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isBitAddr(operands[1]) || operands[1] === '256.0')) {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    } else if (parseInt(operands[0], 10) === sfrMap.get('A')) {
      if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      if (parseInt(operands[1], 10) !== sfrMap.get('A') && operands[1] !== '256') {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    } else {
      return { status: false, msg: 'Invalid 1st operand' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['orl', function (operands) {
  return instructionCheck.get('anl')(operands);
}], ['xrl', function (operands) {
  if (operands.length === 2) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      return { status: false, msg: 'Invalid 1st operand' };
    } else if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
      return { status: false, msg: 'Invalid 2nd operand' };
    } else if (parseInt(operands[0], 10) === sfrMap.get('A')) {
      if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    } else if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      if (parseInt(operands[1], 10) !== sfrMap.get('A') && operands[1] !== '256') {
        return { status: false, msg: 'Invalid 2nd operand' };
      }
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['rl', function (operands) {
  if (operands.length === 1) {
    if (parseInt(operands[0], 10) !== sfrMap.get('A')) {
      return { status: false, msg: 'Operand must be accumulator' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['rlc', function (operands) {
  return instructionCheck.get('rl')(operands);
}], ['rr', function (operands) {
  return instructionCheck.get('rl')(operands);
}], ['rrc', function (operands) {
  return instructionCheck.get('rl')(operands);
}], ['da', function (operands) {
  return instructionCheck.get('rl')(operands);
}], ['swap', function (operands) {
  return instructionCheck.get('rl')(operands);
}], ['xch', function (operands) {
  if (operands.length === 2) {
    if (parseInt(operands[0], 10) !== sfrMap.get('A')) {
      return { status: false, msg: '1st operand must be accumulator' };
    } else if (operands[1] === '256') {
      return { status: false, msg: 'Immediate data is not allowed' };
    } else if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[1])) {
      return { status: false, msg: 'Invalid 2nd operand' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['xchd', function (operands) {
  return instructionCheck.get('xch')(operands);
}], ['push', function (operands) {
  if (operands.length === 1) {
    if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isByteAddr(operands[0])) {
      return { status: false, msg: 'Invalid operand' };
    }
  } else {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['pop', function (operands) {
  return instructionCheck.get('push')(operands);
}], ['inc', function (operands) {
  return instructionCheck.get('push')(operands);
}], ['dec', function (operands) {
  return instructionCheck.get('inc')(operands);
}], ['nop', function (operands) {
  if (operands.length !== 1 || operands[0] !== '') {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['ret', function (operands) {
  if (operands.length !== 1 || operands[0] !== '') {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}], ['reti', function (operands) {
  if (operands.length !== 1 || operands[0] !== '') {
    return { status: false, msg: 'Invalid number of operands' };
  }
  return { status: true };
}]]);

/* harmony default export */ __webpack_exports__["a"] = ({
  sfrMap: sfrMap,
  ram: ram,
  instructionCheck: instructionCheck,
  code: '',
  labels: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(),
  programCounter: 0,
  programCounterStack: []
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__instructions__ = __webpack_require__(147);





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  s*\n  (?:               <Any word or number followed by a colon>\n    [a-zd]+s*?:   <with any number of spaces between>\n  )?\n'], ['\n  \\s*\n  (?:               <Any word or number followed by a colon>\n    [a-z\\d]+\\s*?:   <with any number of spaces between>\n  )?\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  s*?\n  (\n    [a-z]{2,5}      <Any word of length between 2 & 5>\n  )\n  s*\n'], ['\n  \\s*?\n  (\n    [a-z]{2,5}      <Any word of length between 2 & 5>\n  )\n  \\s*\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  (?:\n    d+[da-f]*h    <Hexadecimal numbers followed by \'h\'>\n  )\n  |\n  (?:\n    [01]+b          <Binary numbers followed by \'b\'>\n  )\n  |\n  (?:\n    d+d?           <Decimal numbers followed by an optional \'d\'>\n  )\n'], ['\n  (?:\n    \\d+[\\da-f]*h    <Hexadecimal numbers followed by \'h\'>\n  )\n  |\n  (?:\n    [01]+b          <Binary numbers followed by \'b\'>\n  )\n  |\n  (?:\n    \\d+d?           <Decimal numbers followed by an optional \'d\'>\n  )\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  [a-z]+[0-7]?      <Any word followed by an optional digit>\n  (?:\n    .[0-7]         <followed by an optional dot and digit>\n  )?\n'], ['\n  [a-z]+[0-7]?      <Any word followed by an optional digit>\n  (?:\n    \\.[0-7]         <followed by an optional dot and digit>\n  )?\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n(\n  (?:\n    (?:\n      ', '\n    )\n    |\n    (?:\n      @R[01]        <@ followed by R0 or R1>\n    )\n    |\n    (?:\n      ', '\n    )\n  )\n  (?:\n    s*,s*         <Optional second operand>\n    (?:\n      (?:\n        (?:\n          #|/      <number optionally prefixed with # or />\n        )?\n        (?:\n          ', '\n        )\n      )\n      |\n      (?:\n        @R[01]      <@ followed by R0 or R1>\n      )\n      |\n      (?:\n        ', '\n      )\n    )\n  )?\n  (?:\n    s*,s*         <Optional third operand>\n    (?:\n      [a-z]+s*?    <which is always a label>\n    )\n  )?\n)?s*\n'], ['\n(\n  (?:\n    (?:\n      ', '\n    )\n    |\n    (?:\n      @R[01]        <@ followed by R0 or R1>\n    )\n    |\n    (?:\n      ', '\n    )\n  )\n  (?:\n    \\s*,\\s*         <Optional second operand>\n    (?:\n      (?:\n        (?:\n          #|\\/      <number optionally prefixed with # or />\n        )?\n        (?:\n          ', '\n        )\n      )\n      |\n      (?:\n        @R[01]      <@ followed by R0 or R1>\n      )\n      |\n      (?:\n        ', '\n      )\n    )\n  )?\n  (?:\n    \\s*,\\s*         <Optional third operand>\n    (?:\n      [a-z]+\\s*?    <which is always a label>\n    )\n  )?\n)?\\s*\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  s*\n    (?:\n      (?:           <Anything beginning with ; or //>\n        ;\n        |\n        //\n      )\n      .*\n    )\n'], ['\n  \\s*\n    (?:\n      (?:           <Anything beginning with ; or //>\n        ;\n        |\n        \\/\\/\n      )\n      .*\n    )\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  ^\n    s*             <Any spaces>\n      (?:           <Optional ORG directive which is ignored>\n        ORGs+\n        (?:\n          ', '\n        )\n      )?\n      (?:           <Optional comment>\n        ', '\n      )?\n    s*             <Any spaces after ORG or comment>\n  $\n'], ['\n  ^\n    \\s*             <Any spaces>\n      (?:           <Optional ORG directive which is ignored>\n        ORG\\s+\n        (?:\n          ', '\n        )\n      )?\n      (?:           <Optional comment>\n        ', '\n      )?\n    \\s*             <Any spaces after ORG or comment>\n  $\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default.a(['\n  ^\n    ', '\n    s*\n    (?:\n      END\n    )\n    (?:             <Optional comment>\n      ', '\n    )?\n  $\n'], ['\n  ^\n    ', '\n    \\s*\n    (?:\n      END\n    )\n    (?:             <Optional comment>\n      ', '\n    )?\n  $\n']);





var resetMemory = true;

function commentedRegex(strings) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var string = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(strings.raw).map(function (v, i) {
    return v + (values[i] || '');
  }).join('').value();

  return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(string).replace(/\s+/g, '').replace(/<.*?>/g, '').value();
}

var labelPattern = new RegExp(commentedRegex(_templateObject), 'i');

var instructionPattern = new RegExp(commentedRegex(_templateObject2), 'i');

var numberRegex = commentedRegex(_templateObject3);

var anyRegisterRegex = commentedRegex(_templateObject4);

var operandsPattern = new RegExp(commentedRegex(_templateObject5, numberRegex, anyRegisterRegex, numberRegex, anyRegisterRegex), 'i');

var commentPattern = new RegExp(commentedRegex(_templateObject6));

var ignoreLinePattern = new RegExp(commentedRegex(_templateObject7, numberRegex, commentPattern.source), 'i');

var ENDpattern = new RegExp(commentedRegex(_templateObject8, labelPattern.source, commentPattern.source), 'i');

var codePattern = new RegExp(labelPattern.source + instructionPattern.source + operandsPattern.source + new RegExp(/(.*)/).source, 'i');

function isInt(str) {
  return str.indexOf('.') === -1;
}

function isFloat(str) {
  return str.indexOf('.') !== -1;
}

function isPort(addr) {
  var intAddr = parseInt(addr, 10);
  return intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('P0') || intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('P1') || intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('P2') || intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('P3');
}

function isALU(addr) {
  var intAddr = parseInt(addr, 10);
  return intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('A') || intAddr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('B') || addr === __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('PSW') + '.7';
}

function isRAM(addr) {
  var intAddr = parseInt(addr, 10);
  return intAddr >= 0 && intAddr <= 127;
}

function isSFR(addr) {
  var intAddr = parseInt(addr, 10);
  return intAddr <= 255 && !isPort(addr) && !isALU(addr) && !isRAM(addr);
}

function isRtoR(addr1, addr2) {
  var intAddr1 = parseInt(addr1, 10);
  var intAddr2 = parseInt(addr2, 10);
  return intAddr1 >= 0 && intAddr1 <= 31 && intAddr2 >= 0 && intAddr2 <= 31;
}

function isPortToPort(addr1, addr2) {
  return isPort(addr1) && isPort(addr2);
}

function isSFRtoSFR(addr1, addr2) {
  return isSFR(addr1) && isSFR(addr2);
}

function isBitAddr(addr) {
  var intAddr = parseInt(addr, 10);
  if (isInt(addr)) {
    return intAddr >= 0 && intAddr <= 127;
  }
  if (isFloat(addr)) {
    return intAddr % 8 === 0 && intAddr >= 128 && intAddr <= 256;
  }
  return false;
}

function isByteAddr(addr) {
  var intAddr = parseInt(addr, 10);
  return isInt(addr) && intAddr <= 256;
}

function isLabel(label) {
  return __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].labels.has(label.toLowerCase());
}

function convertToBin(number) {
  var padWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

  var toString = Number.prototype.toString;
  var toBin = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.partialRight(toString.call.bind(toString), 2);
  return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.padStart(toBin(number), padWidth, '0');
}

function changeBit(addr, bit, value) {
  var binary = convertToBin(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[addr]);
  return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(binary).toArray().reverse().tap(function (arr) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(arr, bit, value);
  }).reverse().join('').value();
}

function isBitSet(addr, bit) {
  var binary = convertToBin(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[addr]);
  return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(binary).toArray().reverse().thru(function (arr) {
    return arr[bit] === '1';
  }).value();
}

function convertToDec(op, pattern, base) {
  var _pattern$exec = pattern.exec(op),
      _pattern$exec2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default.a(_pattern$exec, 3),
      _pattern$exec2$ = _pattern$exec2[1],
      addrMode = _pattern$exec2$ === undefined ? '' : _pattern$exec2$,
      number = _pattern$exec2[2];

  var decimal = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt(number, base);
  return '' + addrMode + decimal;
}

function executeFunctionByName(funcName, context, args) {
  var _ctx;

  var namespaces = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(funcName, '.');
  var func = namespaces.pop();
  var ctx = context;
  __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(namespaces, function (nmsp) {
    ctx = ctx[nmsp];
  });
  return (_ctx = ctx)[func].apply(_ctx, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default.a(args));
}

function handleRegisters(reg) {
  return reg.replace(/^C$/i, __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('PSW') + '.7').replace(/^(@)?([a-z]{1,4}[0-3]?)(\.[0-7])?$/i, function (match) {
    var addrMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var sfr = arguments[2];
    var bit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var sfrAddr = __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toUpper(sfr));
    if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(sfrAddr)) {
      sfrAddr = sfr;
    }
    return '' + addrMode + sfrAddr + bit;
  }).replace(/^(@)?R([0-7])$/i, function (match) {
    var addrMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var number = arguments[2];

    var regBankMode = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt(convertToBin(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('PSW')]).slice(3, 5), 2);
    return '' + addrMode + (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt(number) + regBankMode * 8);
  });
}

function translateToBitAddressable(op) {
  var _$chain$split$map$val = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(op).split('.').map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt).value(),
      _$chain$split$map$val2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default.a(_$chain$split$map$val, 2),
      addr = _$chain$split$map$val2[0],
      bit = _$chain$split$map$val2[1];

  if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.inRange(addr, 128) && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(bit)) {
    return [__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.toInteger(addr / 8) + 32, addr % 8];
  }
  return [addr, bit];
}

function handleAddressingMode(op) {
  var number = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt(op.slice(1));
  if (/^#/i.test(op)) {
    __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[256] = number;
    return '256';
  } else if (/^@/i.test(op)) {
    return '' + __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[number];
  } else if (/^\//i.test(op)) {
    var _translateToBitAddres = translateToBitAddressable(op.slice(1)),
        _translateToBitAddres2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default.a(_translateToBitAddres, 2),
        byteAddr = _translateToBitAddres2[0],
        bit = _translateToBitAddres2[1];

    __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[256] = isBitSet(byteAddr, bit) ? 0 : 1;
    return '256.0';
  }
  return op;
}

function parseLine(code) {
  var valid = { status: true };

  var _codePattern$exec = codePattern.exec(code),
      _codePattern$exec2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default.a(_codePattern$exec, 4),
      instruction = _codePattern$exec2[1],
      _codePattern$exec2$ = _codePattern$exec2[2],
      operands = _codePattern$exec2$ === undefined ? [] : _codePattern$exec2$,
      unexpectedChars = _codePattern$exec2[3];

  instruction = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.replace(instruction, /\s+/g, '').toLowerCase();

  operands = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(operands).replace(/\s+/g, '').split(',').value();

  if (unexpectedChars.length > 0 && !commentPattern.test(unexpectedChars)) {
    valid = { status: false, msg: 'Invalid operand(s)' };
  }

  var countOfRegBank = 0;
  var containsA = false;
  __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(operands, function (operand, index) {
    var op = operand;
    if (/^(?:@)?R[0-7]$/i.test(op)) {
      countOfRegBank += 1;
    }
    if (/[\da-f]+h$/i.test(op)) {
      op = convertToDec(op, /(@|#|\/)?([\da-f]+)h/i, 16);
    } else if (/[01]+b$/i.test(op)) {
      op = convertToDec(op, /(@|#|\/)?([01]+)b/i, 2);
    } else if (/\d+d$/i.test(op)) {
      op = op.slice(0, -1);
    }

    op = handleRegisters(op);

    op = handleAddressingMode(op);

    if (/^224(?:\.[0-7])?$/.test(op)) {
      containsA = true;
    }

    operands[index] = op;
  });

  var instructionCheck = __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].instructionCheck.get(instruction);

  if (valid.status) {
    if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(instructionCheck)) {
      valid = { status: false, msg: 'Invalid instruction' };
    } else if (countOfRegBank > 1) {
      valid = { status: false, msg: 'Both operands cannot access register bank simultaneously' };
    } else {
      valid = instructionCheck(operands);
    }
  }

  if (valid.status) {
    var executionError = executeFunctionByName(instruction, __WEBPACK_IMPORTED_MODULE_6__instructions__["a" /* default */], operands);
    if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(executionError)) {
      valid = executionError;
    }
    if (containsA) {
      __WEBPACK_IMPORTED_MODULE_6__instructions__["a" /* default */].updateParity();
    }
  }
  return valid;
}

function initMemory() {
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram.set(new Uint8Array(257));
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].ram[__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].sfrMap.get('SP')] = 0x07;
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code = '';
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].labels = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter = 0;
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounterStack = [];
}

function initValues(input) {
  initMemory();
  var code = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(input, '\n');

  __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(code, function (line, index) {
    code[index] = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(line);

    var _labelPattern$exec = labelPattern.exec(line),
        _labelPattern$exec2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default.a(_labelPattern$exec, 1),
        label = _labelPattern$exec2[0];

    if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isUndefined(label) && label !== '') {
      label = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(label.slice(0, -1));
      __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].labels.set(label.toLowerCase(), index);
    }
  });
  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code = code;
  resetMemory = false;
}

function executeNextLine(input) {
  if (resetMemory) {
    initValues(input);
  }

  var lineNumber = __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter;
  var executionStatus = { status: true };

  __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter += 1;

  if (ENDpattern.test(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code[__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter - 1])) {
    resetMemory = true;
    __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter = __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code.length + 1;
  } else if (!ignoreLinePattern.test(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code[__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter - 1])) {
    executionStatus = parseLine(__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code[__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter - 1]);
  }

  if (__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter >= __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code.length || !executionStatus.status) {
    resetMemory = true;
  }

  executionStatus.line = lineNumber;
  executionStatus.nextLine = __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter;
  return executionStatus;
}

function handleExecution(input) {
  initValues(input);
  var executionStatus = { status: true };

  while (__WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].programCounter < __WEBPACK_IMPORTED_MODULE_5__data__["a" /* default */].code.length && executionStatus.status) {
    executionStatus = executeNextLine(input);
  }
  return executionStatus;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  isPort: isPort,
  isALU: isALU,
  isRAM: isRAM,
  isSFR: isSFR,
  isRtoR: isRtoR,
  isPortToPort: isPortToPort,
  isSFRtoSFR: isSFRtoSFR,
  isBitAddr: isBitAddr,
  isByteAddr: isByteAddr,
  isLabel: isLabel,
  changeBit: changeBit,
  convertToBin: convertToBin,
  parseLine: parseLine,
  executeNextLine: executeNextLine,
  handleExecution: handleExecution,
  handleRegisters: handleRegisters,
  initValues: initValues,
  isBitSet: isBitSet,
  translateToBitAddressable: translateToBitAddressable
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SevenSegment__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Motor__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AdcDacSlider__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__back_end_8051__ = __webpack_require__(119);













__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: [{
    path: '/seven-segment', component: __WEBPACK_IMPORTED_MODULE_6__components_SevenSegment__["a" /* default */]
  }, {
    path: '/motor', component: __WEBPACK_IMPORTED_MODULE_7__components_Motor__["a" /* default */]
  }, {
    path: '/adc-dac', component: __WEBPACK_IMPORTED_MODULE_8__components_AdcDacSlider__["a" /* default */]
  }]
});

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    memory: __WEBPACK_IMPORTED_MODULE_9__back_end_8051__["a" /* default */].memory,
    utils: __WEBPACK_IMPORTED_MODULE_9__back_end_8051__["a" /* default */].utils
  },
  mutations: {
    debug: function debug(state, code) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'result', __WEBPACK_IMPORTED_MODULE_9__back_end_8051__["a" /* default */].debug(code));
    },
    run: function run(state, code) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'result', __WEBPACK_IMPORTED_MODULE_9__back_end_8051__["a" /* default */].run(code));
    },
    reset: function reset(state, code) {
      __WEBPACK_IMPORTED_MODULE_9__back_end_8051__["a" /* default */].reset(code);
    },
    setPort: function setPort(state, _ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a(_ref, 2),
          port = _ref2[0],
          value = _ref2[1];

      state.memory.ram[state.memory.sfrMap.get('P' + port)] = value;
    }
  }
});

var _loop = function _loop(k, v) {
  store.getters['get' + k] = function () {
    return store.state.memory.ram[v];
  };
};

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(store.state.memory.sfrMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var _ref3 = _step.value;

    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a(_ref3, 2);

    var k = _ref4[0];
    var v = _ref4[1];

    _loop(k, v);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1609490c_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1609490c_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 76:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semantic_ui_css_semantic_min_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semantic_ui_css_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_semantic_ui_css_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IntroModal__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PinDiagram__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Memory__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor__ = __webpack_require__(93);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showModal: true
    };
  },

  components: {
    IntroModal: __WEBPACK_IMPORTED_MODULE_1__components_IntroModal__["a" /* default */],
    PinDiagram: __WEBPACK_IMPORTED_MODULE_2__components_PinDiagram__["a" /* default */],
    Memory: __WEBPACK_IMPORTED_MODULE_3__components_Memory__["a" /* default */],
    Editor: __WEBPACK_IMPORTED_MODULE_4__components_Editor__["a" /* default */]
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroModal_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3e8425_node_modules_vue_loader_lib_selector_type_template_index_0_IntroModal_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f3e8425"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3e8425_node_modules_vue_loader_lib_selector_type_template_index_0_IntroModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeModal: function closeModal() {
      document.cookie = 'firstVisit=false; path=/';
      this.$emit('closeModal');
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"](document.cookie, 'firstVisit')) {
      this.closeModal();
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui active small modal",
    attrs: {
      "id": "intro-modal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Important Note")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui positive button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("OK")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n      This simulator does not support Timer and Serial programs.\n      So, registers related to those programs will not work as expected.\n      They are treated as normal registers.\n    ")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v("HERE: JNB P0.0 HERE")])]), _vm._v(" "), _c('p', [_vm._v("\n      Infinitely looping code, such as the one above, which relies on external input(s) to\n      break the loop "), _c('strong', [_vm._v("will")]), _vm._v(" hang the site, prompting you to reload the site.\n    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinDiagram_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b9db82_node_modules_vue_loader_lib_selector_type_template_index_0_PinDiagram_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75b9db82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinDiagram_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b9db82_node_modules_vue_loader_lib_selector_type_template_index_0_PinDiagram_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */](['getP0', 'getP1', 'getP2', 'getP3']),
  mounted: function mounted() {
    var _this = this;

    var toBin = this.$store.state.utils.convertToBin;
    this.$store.subscribe(function () {
      __WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_1_lodash__["range"](4), function (i) {
        var port = toBin(_this['getP' + i]());
        __WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_1_lodash__["range"](8), function (j) {
          var elt = _this.$el.querySelector('#port' + i + j);
          elt.setAttribute('class', port[7 - j] === '1' ? 'high' : 'low');
        });
      });
    });
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 684.4 1043"
    }
  }, [_c('g', {
    attrs: {
      "font-size": "40",
      "font-family": "sans-serif",
      "letter-spacing": "0",
      "word-spacing": "0"
    }
  }, [_c('text', {
    attrs: {
      "x": "583.4",
      "y": "29.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("Vcc")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "1035.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "982.6",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "930",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "876.9",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "824.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "771.1",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "717.9",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "665.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "612.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("PSEN")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "559.6",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("ALE")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "507.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("EA")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "82.7",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "135.8",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "189",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "242.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "295.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "348.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "401.7",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "454.8",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "29.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "1035.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("GND")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "982.6",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("XTAL1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "930",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("XTAL2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "876.9",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "824.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "771.1",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "717.9",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "665.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "612.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "559.6",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "507.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "82.7",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "135.8",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "189",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "242.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "295.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "348.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "401.7",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "454.8",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("RST")])])]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#9e9e9e",
      "stroke": "#000",
      "transform": "translate(-19.082 -4.887)"
    }
  }, [_c('rect', {
    attrs: {
      "width": "399",
      "height": "1040.1",
      "x": "-571.5",
      "y": "7.3",
      "transform": "scale(-1 1)",
      "ry": "5.2",
      "rx": "4.3"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "250.9",
      "y": "565.3",
      "font-size": "107.1",
      "font-family": "sans-serif",
      "transform": "translate(-19.082 -3.816)"
    }
  }, [_c('tspan', [_vm._v("8051")])]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "stroke": "#000",
      "stroke-width": "3.1"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(59.526 -.778) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "high",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 51.96) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port00",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 104.696) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port01",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 157.433) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port02",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 210.17) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port03",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 262.906) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port04",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 315.643) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port05",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 368.38) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port06",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 421.117) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port07",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 473.854) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 526.59) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 579.328) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 632.064) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port27",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 684.8) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port26",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 737.538) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port25",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 790.275) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port24",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 843.012) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port23",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 895.75) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port22",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 948.485) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port21",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 1001.222) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port20",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 -.778)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port10",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 51.96)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port11",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 104.696)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port12",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 157.433)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port13",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 210.17)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port14",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 262.906)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port15",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 315.643)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port16",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 368.38)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port17",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 421.117)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 473.854)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port30",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 526.59)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port31",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 579.328)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port32",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 632.064)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port33",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 684.8)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port34",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 737.538)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port35",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 790.275)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port36",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 843.012)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port37",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 895.75)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 948.485)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 1001.222)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memory_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7de40f6_node_modules_vue_loader_lib_selector_type_template_index_0_Memory_vue__ = __webpack_require__(92);
function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7de40f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7de40f6_node_modules_vue_loader_lib_selector_type_template_index_0_Memory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sfrs: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */](['memory']),
  methods: {
    toHex: function toHex(value) {
      return '0x' + __WEBPACK_IMPORTED_MODULE_3_lodash__["padStart"](__WEBPACK_IMPORTED_MODULE_3_lodash__["parseInt"](value).toString(16), 2, '0');
    },
    updateMemory: function updateMemory() {
      var temp = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a(this.memory.sfrMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a(_ref, 2);

          var k = _ref2[0];
          var v = _ref2[1];

          temp.push({ sfr: k, value: this.memory.ram[v] });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.sfrs = temp;
    }
  },
  created: function created() {
    this.updateMemory();
    this.$store.subscribe(this.updateMemory);
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "eight wide column"
  }, [_c('table', {
    staticClass: "ui small very basic very compact center aligned table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sfrs), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.sfr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.toHex(item.value)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "eight wide column"
  }, [_c('table', {
    staticClass: "ui small very basic very compact center aligned table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.memory.ram.slice(0, 128)), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.toHex(index)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.toHex(item)))])])
  }))])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SFR")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0ba41e_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e0ba41e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0ba41e_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_brace__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_brace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_brace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_theme_tomorrow__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_theme_tomorrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_brace_theme_tomorrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_mode_assembly_x86__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_mode_assembly_x86___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_mode_assembly_x86__);










var Range = __WEBPACK_IMPORTED_MODULE_3_brace___default.a.acequire('ace/range').Range;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      code: '',
      errorMessage: '',
      isError: false,
      lineNumber: 0,
      markers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var editor = __WEBPACK_IMPORTED_MODULE_3_brace___default.a.edit(this.$el.querySelector('#ace-editor'));
    var editorSession = editor.getSession();
    this.e = editorSession;

    editor.setTheme('ace/theme/tomorrow');
    editorSession.setMode('ace/mode/assembly_x86');

    this.$el.querySelector('#run-btn').addEventListener('click', function () {
      return _this.runEditor();
    });
    this.$el.querySelector('#debug-btn').addEventListener('click', function () {
      return _this.debugEditor();
    });
    this.$el.querySelector('#reset-btn').addEventListener('click', function () {
      return _this.resetEditor();
    });
    editorSession.on('change', function () {
      return _this.resetEditor();
    });
    window.addEventListener('beforeunload', function (e) {
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](editor.getValue())) {
        e.preventDefault();
      }
    });

    editor.focus();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a({}, __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */](['run', 'debug', 'reset']), {
    runEditor: function runEditor() {
      this.run(this.e.getValue());
      this.highlightLine();
    },
    debugEditor: function debugEditor() {
      this.debug(this.e.getValue());
      this.highlightLine();
    },
    resetEditor: function resetEditor() {
      this.removeMarkers();
      this.reset(this.e.getValue());
    },
    highlightLine: function highlightLine() {
      var _this2 = this;

      this.removeMarkers();
      var result = this.$store.state.result;

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](result.line)) {
        this.markers.push(this.e.addMarker(new Range(result.line, 0, result.line, Infinity), 'highlight-line ' + (result.status ? 'current' : 'error'), 'fullLine'));
      }

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](result.nextLine)) {
        this.markers.push(this.e.addMarker(new Range(result.nextLine, 0, result.nextLine, Infinity), 'highlight-line next', 'fullLine'));
      }

      if (!result.status) {
        this.isError = true;
        __WEBPACK_IMPORTED_MODULE_1_lodash__["delay"](function () {
          _this2.isError = false;
        }, 2000);
        this.errorMessage = result.msg;
        this.lineNumber = result.line + 1;
      }
    },
    removeMarkers: function removeMarkers() {
      var _this3 = this;

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"](this.markers)) {
        __WEBPACK_IMPORTED_MODULE_1_lodash__["forEach"](this.markers, function (marker) {
          _this3.e.removeMarker(marker);
        });
        this.markers.length = 0;
      }
    }
  })
});

/***/ })

},[53]);


// WEBPACK FOOTER //
// static/js/app.109bcf810e79874bcdac.js